module.exports = __webpack_public_path__ + "img/partizani-tirana-logo-icon.0a577202.png";